<template>
  <section ref="regalosRef" class="regalos-wrapper">
    <h2 ref="tituloRef" class="titulo-script">Opción de regalo</h2>

    <p ref="texto1Ref" class="texto">
      Tu presencia en nuestro día especial es el mejor regalo que podríamos desear.
    </p>

    <p ref="texto2Ref" class="texto">
      Pero si es tu deseo te dejamos la siguiente opción, sin embargo cualquier detalle es bienvenido.
    </p>

    <div ref="iconoRef" class="icono-wrap">
      <img
        src="@/assets/SOBRE.avif"
        alt="Sobre regalo"
        class="sobre-negro"
      />
    </div>

    <p ref="tituloSobreRef" class="titulo-sobre">Sobrecito de amor</p>

    <p ref="buzonRef" class="texto">
      Pueden encontrar un sobre y un buzón en la recepción.
    </p>

    <p ref="graciasRef" class="gracias">¡Gracias!</p>
  </section>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'RegalosElegantes',
  setup() {
    const regalosRef = ref(null)
    const tituloRef = ref(null)
    const texto1Ref = ref(null)
    const texto2Ref = ref(null)
    const iconoRef = ref(null)
    const tituloSobreRef = ref(null)
    const buzonRef = ref(null)
    const graciasRef = ref(null)

    onMounted(async () => {
      await nextTick()

      // 🔹 Estados iniciales (claros pero no exagerados)
      gsap.set(tituloRef.value, { y: 40, opacity: 0 })
      gsap.set(texto1Ref.value, { x: -30, opacity: 0 })
      gsap.set(texto2Ref.value, { x: 30, opacity: 0 })
      gsap.set(iconoRef.value, { scale: 0.5, rotate: -8, opacity: 0 })
      gsap.set(tituloSobreRef.value, { y: 25, opacity: 0 })
      gsap.set(buzonRef.value, { y: 25, opacity: 0 })
      gsap.set(graciasRef.value, { scale: 0.8, opacity: 0 })

      gsap.timeline({
        scrollTrigger: {
          trigger: regalosRef.value,
          start: 'top 85%',
          toggleActions: 'play none none none',
          once: true
        },
        defaults: { ease: 'power2.out' }
      })
        // TÍTULO
        .to(tituloRef.value, {
          y: 0,
          opacity: 1,
          duration: 0.6
        })

        // TEXTOS (ENTRAN EN OPOSICIÓN)
        .to(texto1Ref.value, {
          x: 0,
          opacity: 1,
          duration: 0.45
        }, '-=0.2')
        .to(texto2Ref.value, {
          x: 0,
          opacity: 1,
          duration: 0.45
        }, '-=0.25')

        // ICONO (POP ELEGANTE)
        .to(iconoRef.value, {
          scale: 1,
          rotate: 0,
          opacity: 1,
          duration: 0.5,
          ease: 'back.out(1.7)'
        })

        // TEXTO SOBRECITO
        .to(tituloSobreRef.value, {
          y: 0,
          opacity: 1,
          duration: 0.4
        }, '-=0.15')

        // BUZÓN
        .to(buzonRef.value, {
          y: 0,
          opacity: 1,
          duration: 0.4
        }, '-=0.25')

        // GRACIAS (MICRO ZOOM)
        .to(graciasRef.value, {
          scale: 1,
          opacity: 1,
          duration: 0.4
        }, '-=0.2')

      ScrollTrigger.refresh()
    })

    return {
      regalosRef,
      tituloRef,
      texto1Ref,
      texto2Ref,
      iconoRef,
      tituloSobreRef,
      buzonRef,
      graciasRef
    }
  }
}
</script>

<style scoped>
.regalos-wrapper {
  background-color: #efe6dc;
  padding: 80px 24px;
  text-align: center;
  max-width: 420px;
  margin: 0 auto;
}

/* TÍTULO */
.titulo-script {
  font-family: 'cursiva', cursive;
  font-size: 46px;
  margin-bottom: 28px;
  color: #7a5a35 !important;
  -webkit-text-fill-color: #7a5a35 !important;
}

/* TEXTO */
.texto {
  font-family: 'Playfair Display', serif;
  font-size: 15px;
  line-height: 1.7;
  color: black;
  margin-bottom: 14px;
}

/* ICONO */
.icono-wrap img {
  width: 64px;
  margin: 26px auto 16px;
  display: block;
}

.sobre-negro {
  filter: brightness(0);
}

/* TÍTULO SOBRECITO */
.titulo-sobre {
  font-family: 'Playfair Display', serif;
  font-size: 20px;
  color: black;
  margin-bottom: 6px;
}

/* GRACIAS */
.gracias {
  font-family: 'Playfair Display', serif;
  font-size: 18px;
  letter-spacing: 1px;
  color: black;
  margin-top: 16px;
}
</style>
